import React, { FC, useContext } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBell } from "@fortawesome/pro-duotone-svg-icons"
import { authContext } from "../../../context/auth/authContext"
import { Badge, Button, Row } from "react-bootstrap"
import classes from "./WelcomeAlert.module.scss"

const WelcomeAlert: FC = () => {
  const context = useContext(authContext)
  const [notifications] = React.useState(0)

  return (
    <Row className="mt-auto mb-auto">
      <p className="text-dark mt-auto mb-auto d-none d-md-inline">
        Welcome {context.user.username}
      </p>
      <Button variant="link ml-2 mr-2">
        <FontAwesomeIcon
          icon={faBell}
          className="text-black-50 mt-auto mb-auto"
          size="lg"
        />
        {notifications > 0 && (
          <Badge variant="danger" className={classes.notificationBadge}>
            {notifications}
          </Badge>
        )}
      </Button>
    </Row>
  )
}

export default WelcomeAlert
